module.exports = __webpack_public_path__ + "static/media/foto_polo_filter.73bee9a9.jpg";